import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
});

// Attach JWT to every request if present
api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('ar_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// On 401, clear session and redirect to login
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('ar_token');
      localStorage.removeItem('ar_user');
      localStorage.removeItem('ar_active_vehicle');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export async function login(username, password) {
  const { data } = await api.post('/auth/login', { username, password });
  return data;   // { success, message, data: { token, user, last_activity } }
}

export async function getVehicles() {
  const { data } = await api.get('/vehicles');
  return data;
}

export default api;
